import React from "react";
import { withRouter } from "react-router-dom";
import FormBuilder from "../../../toolkit/baseForms2/formBuilder/FormBuilder";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./styles.scss";
import { formConfig, Inputs, Buttons } from "./filtros.form";
import IUserSelectorBuilder from "../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";
import { Container, Row, Col, Button, Alert } from "reactstrap";
import ReactTable from "react-table";
import { columns } from "./columns";
import {
  comisionesTycPagadas,
  comisionesTycOpciones
} from "../../actions/reports";
import {
  errorNotification,
  infoNotification,
  successNotification,
  warnNotification
} from "../../../utils/notifications";
import MexicanCurrency from "../common/currency/index";
import ISelectBuilder from "../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";

interface Props {}

interface State {
  loadingForm: boolean;
  initForm: { [key in Inputs]: any };
  data: any[];
  totalComision: any;
  totalImporte: any;
  opciones: any[];
  exporting: boolean;
}

class ComisionesTycPagadasPage extends React.Component<Props, State> {
  state = {
    loadingForm: false,
    initForm: null,
    data: null,
    totalComision: null,
    totalImporte: null,
    opciones: null,
    exporting: false
  };

  componentDidMount(): void {
    comisionesTycOpciones()
      .then(response => {
        this.setState({
          opciones: response.data
        });
      })
      .catch(_ => {
        errorNotification("No se pudieron consultar los periodos");
      });
  }

  submit = values => {
    if (!values.empleado) {
      errorNotification("Seleccione al empleado");
      return;
    }

    if (!values.periodo) {
      errorNotification("Seleccione el periodo de búsqueda");
      return;
    }

    const valuesPeriodo = (values.periodo as string).split("::");
    const quincena = valuesPeriodo[0];
    const periodo = valuesPeriodo[1];
    infoNotification("Buscando comisiones...");
    this.setState({
      loadingForm: true,
      data: null,
      totalComision: null,
      totalImporte: null
    });

    comisionesTycPagadas(values.empleado, periodo, quincena)
      .then(response => {
        if (
          response.data.advertencias &&
          response.data.advertencias.length > 0
        ) {
          response.data.advertencias.forEach(msg => warnNotification(msg));
        }

        this.setState({
          data: response.data.comisiones,
          totalComision: response.data.totalComision,
          totalImporte: response.data.totalImporte,
          loadingForm: false
        });

        successNotification("Comisiones consultadas correctamente");
      })
      .catch(error => {
        let errorMsg = "Ocurrió un error";

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMsg = error.response.data.message;
        } else if (error && error.message) {
          errorMsg = error.message;
        }

        warnNotification(errorMsg);

        this.setState({
          loadingForm: false
        });
      });
  };

  handleExport = () => {
    try {
      if (!this.state.data || this.state.data.length === 0) {
        errorNotification("No hay datos para exportar");
        return;
      }

      const headers = [
        "SISTEMA",
        "ID COMISION",
        "FOLIO FACTURA",
        "FECHA AUTORIZACION",
        "USUARIO AUTORIZACION",
        "CLUB",
        "TIPO COMISION",
        "ESTATUS",
        "IMPORTE",
        "DESCRIPCION",
        "MONTO",
        "PORCENTAJE"
      ];
      const csvRows = [];

      csvRows.push(headers.join(","));

      this.state.data.forEach(comision => {
        const values = [
          comision.sistema || "N/A",
          comision.idComision || "",
          comision.folioFactura || "",
          comision.fechaAutorizacion || "",
          comision.usuarioAutorizacion || "",
          comision.club || "",
          comision.tipocomision || "",
          comision.estatusComision || "",
          comision.importe || 0,
          comision.descripcion || "",
          comision.montoComision || 0,
          comision.porcentaje || 0
        ].map(value => {
          const stringValue = String(value);
          if (
            stringValue.includes(",") ||
            stringValue.includes('"') ||
            stringValue.includes("\n")
          ) {
            return `"${stringValue.replace(/"/g, '""')}"`;
          }
          return stringValue;
        });

        csvRows.push(values.join(","));
      });

      csvRows.push("");

      csvRows.push(
        [
          "",
          "",
          "",
          "",
          "",
          this.state.totalImporte || 0,
          "TOTALES",
          this.state.totalComision || 0,
          ""
        ].join(",")
      );

      const csvContent = csvRows.join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

      const now = new Date();
      const dateStr = `${now.getFullYear()}-${String(
        now.getMonth() + 1
      ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", `comisiones_pagadas_${dateStr}.csv`);
      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

      successNotification("Comisiones exportadas correctamente");
    } catch (error) {
      console.error("Error al exportar comisiones:", error);
      errorNotification("Ocurrió un error al exportar las comisiones");
    }
  };

  render() {
    const hayDatos = !!this.state.data && this.state.data.length > 0;

    return (
      <Container className="mb-5 mt-3">
        <Alert color="danger">
          <strong>Aviso:</strong> Ya no debería utilizar este reporte porque se
          descontinuará pronto, vaya al menú{" "}
          <strong>Comisiones / Comisiones Pagadas</strong>
        </Alert>

        <FormBuilder<Inputs, Buttons>
          config={formConfig}
          init={this.state.initForm}
          submit={this.submit}
          loading={this.state.loadingForm || !this.state.opciones}
        >
          <IUserSelectorBuilder
            name="empleado"
            includeSystemUsers={true}
            useNumeroEmpleado
          />
          <ISelectBuilder name="periodo" data={this.state.opciones || []} />
        </FormBuilder>

        {hayDatos && (
          <Row>
            <Col lg={12}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <p className="primaryTitle">
                  Comisión total:&nbsp;
                  <MexicanCurrency quantity={this.state.totalComision} />
                </p>
                <Button
                  color="primary"
                  onClick={this.handleExport}
                  disabled={!hayDatos || this.state.loadingForm}
                >
                  {this.state.loadingForm ? "Cargando..." : "Exportar a CSV"}
                </Button>
              </div>
              <ReactTable
                data={this.state.data}
                columns={columns}
                className="mt-2"
                resizable={true}
                sortable={false}
                loading={this.state.loadingForm}
                showPagination={false}
                pageSize={
                  this.state.data.length > 10 ? this.state.data.length : 10
                }
              />
            </Col>
          </Row>
        )}
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(ComisionesTycPagadasPage));
